import React, { useState } from 'react';
import { ChartBarIcon, CurrencyDollarIcon } from '../utils/icons';
import Tabs from '../components/ui/Tabs';
import SpendingInsights from '../components/SpendingInsights';
import BudgetManager from '../components/BudgetManager';
import BudgetSidebar from '../components/BudgetSidebar';

const initialCategories = [
  { id: 1, name: 'Groceries', count: 4 },
  { id: 2, name: 'Dining Out', count: 2 },
  { id: 3, name: 'Entertainment', count: 3 },
  { id: 4, name: 'Transportation', count: 1 },
];

const Budgets = () => {
  const [activeTab, setActiveTab] = useState('budget');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeCategory, setActiveCategory] = useState(null);
  const [categories, setCategories] = useState(initialCategories);

  const handleSelectCategory = (categoryId) => {
    setActiveCategory(categoryId === activeCategory ? null : categoryId);
  };

  const handleCreateNew = () => {
    // Optionally open a modal or set state for new category
    // For now, just clear active
    setActiveCategory(null);
  };

  const tabs = [
    {
      id: 'budget',
      label: 'Budget Manager',
      icon: CurrencyDollarIcon,
      count: 4, // Example count, can be dynamic
    },
    {
      id: 'insights',
      label: 'Spending Trends',
      icon: ChartBarIcon,
    },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
          Budgets & Spending
        </h1>
        <p className="text-gray-600 mt-1">Track and manage your spending against budgets.</p>
      </div>

      <div className="flex gap-4">
        {/* Collapsible Sidebar */}
        <div className={`transition-all duration-200 ${sidebarOpen ? 'w-64' : 'w-0'} flex-shrink-0`}>
          {sidebarOpen && (
            <BudgetSidebar
              categories={categories}
              activeCategory={activeCategory}
              onSelectCategory={handleSelectCategory}
              onCreateNew={handleCreateNew}
            />
          )}
        </div>
        {/* Main Content */}
        <div className="flex-1">
          <div className="mb-8">
            <Tabs 
              tabs={tabs} 
              activeTab={activeTab} 
              onTabChange={setActiveTab} 
              className="mb-8"
            />
            {/* Sidebar Toggle Button */}
            <button
              className="md:hidden mb-4 px-3 py-2 rounded bg-gray-100 text-gray-700 hover:bg-gray-200"
              onClick={() => setSidebarOpen((open) => !open)}
            >
              {sidebarOpen ? 'Hide Categories' : 'Show Categories'}
            </button>
            {/* Tab Content */}
            <div className="mt-6">
              {activeTab === 'budget' && <BudgetManager activeCategory={activeCategory} />}
              {activeTab === 'insights' && <SpendingInsights />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Budgets;
